<div class="users-page">

  <!-- Page header -->
  <div class="page-header">
    <div class="header-left">
      <a routerLink="/admin" class="back-link">
        <mat-icon>arrow_back</mat-icon> Admin
      </a>
      <h1>User Management</h1>
      <p class="subtext">View and manage all registered accounts</p>
    </div>
    <div class="header-stats">
      <div class="stat-chip">
        <span class="stat-num">{{ users.length }}</span>
        <span class="stat-label">Total</span>
      </div>
      <div class="stat-chip chip-customer">
        <span class="stat-num">{{ customerCount }}</span>
        <span class="stat-label">Customers</span>
      </div>
      <div class="stat-chip chip-provider">
        <span class="stat-num">{{ providerCount }}</span>
        <span class="stat-label">Providers</span>
      </div>
      <div class="stat-chip chip-admin">
        <span class="stat-num">{{ adminCount }}</span>
        <span class="stat-label">Admins</span>
      </div>
    </div>
  </div>

  <!-- Alerts -->
  <div class="alert alert-success" *ngIf="deleteSuccess || roleSuccess">
    <mat-icon>check_circle</mat-icon>
    {{ deleteSuccess || roleSuccess }}
  </div>
  <div class="alert alert-error" *ngIf="error || roleError">
    <mat-icon>error</mat-icon>
    {{ error || roleError }}
    <button class="retry-btn" *ngIf="error" (click)="loadUsers()">Retry</button>
  </div>

  <!-- Filters row -->
  <div class="filters-row">
    <div class="search-box">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        type="text"
        placeholder="Search by name, username or email..."
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        class="search-input"
      />
    </div>
    <div class="role-filters">
      <button class="filter-btn" [class.active]="roleFilter === ''" (click)="onRoleFilter('')">All</button>
      <button class="filter-btn" [class.active]="roleFilter === 'customer'" (click)="onRoleFilter('customer')">Customers</button>
      <button class="filter-btn" [class.active]="roleFilter === 'provider'" (click)="onRoleFilter('provider')">Providers</button>
      <button class="filter-btn filter-btn-admin" [class.active]="roleFilter === 'admin'" (click)="onRoleFilter('admin')">Admins</button>
    </div>
  </div>

  <!-- Loading skeleton -->
  <div class="loading-wrap" *ngIf="loading">
    <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]"></div>
  </div>

  <!-- Users table -->
  <div class="table-wrap" *ngIf="!loading && !error">
    <table class="users-table" *ngIf="filteredUsers.length > 0; else noResults">
      <thead>
        <tr>
          <th>User</th>
          <th>Username</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of filteredUsers">
          <td class="user-cell">
            <div class="avatar" [class.avatar-admin]="user.role === 'admin'">
              <mat-icon *ngIf="user.role === 'admin'" class="avatar-icon">admin_panel_settings</mat-icon>
              <span *ngIf="user.role !== 'admin'">{{ getInitials(user) }}</span>
            </div>
            <div>
              <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
              <div class="user-id">#{{ user.id }}</div>
            </div>
          </td>
          <td>{{ user.username }}</td>
          <td class="email-cell">{{ user.email }}</td>
          <td>{{ user.phone || '—' }}</td>

          <!-- Role cell — show editor or badge -->
          <td class="role-cell">
            <ng-container *ngIf="editingRoleUserId === user.id; else roleBadge">
              <div class="role-editor">
                <select [(ngModel)]="editingRole" class="role-select">
                  <option value="customer">Customer</option>
                  <option value="provider">Provider</option>
                  <option value="admin">Admin</option>
                </select>
                <button class="btn-role-save" (click)="saveRole(user)" matTooltip="Save">
                  <mat-icon>check</mat-icon>
                </button>
                <button class="btn-role-cancel" (click)="cancelRoleEdit()" matTooltip="Cancel">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </ng-container>
            <ng-template #roleBadge>
              <div class="role-badge-wrap">
                <span class="role-badge" [ngClass]="getRoleBadge(user.role)">
                  <mat-icon class="role-badge-icon">{{ getRoleIcon(user.role) }}</mat-icon>
                  {{ user.role || 'customer' }}
                </span>
                <button class="btn-edit-role" (click)="startEditRole(user)" matTooltip="Change role">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </ng-template>
          </td>

          <td class="actions-cell">
            <button class="btn-delete" (click)="requestDelete(user.id)" matTooltip="Delete user">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #noResults>
      <div class="empty-state">
        <mat-icon>people_outline</mat-icon>
        <p>No users match your search.</p>
        <button class="filter-btn active" (click)="searchTerm=''; roleFilter=''; applyFilters()">Clear filters</button>
      </div>
    </ng-template>
  </div>

  <!-- Confirm delete dialog -->
  <div class="overlay" *ngIf="confirmDeleteId !== null">
    <div class="confirm-dialog">
      <mat-icon class="dialog-icon">warning</mat-icon>
      <h3>Delete User?</h3>
      <p>This action cannot be undone. The user's data will be permanently removed.</p>
      <div class="dialog-actions">
        <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
        <button class="btn-confirm-delete" (click)="confirmDelete()">Delete</button>
      </div>
    </div>
  </div>

</div>
